// Card 17trt6jbffe: horarios do chat. As mensagens sao instantes reais (UTC)
// e chegam da API como ISO com "Z". Exibimos sempre no relogio da escola
// (America/Sao_Paulo), o mesmo criterio do formatSchoolTime da API, para o
// "hoje"/"ontem" nao depender do fuso do aparelho.
import i18n, { languageTag } from "@/plugins/i18n";

const SCHOOL_TIMEZONE = "America/Sao_Paulo";

const dayKeyFormat = new Intl.DateTimeFormat("en-CA", {
  timeZone: SCHOOL_TIMEZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});
// Formatadores por idioma, criados sob demanda (o idioma pode mudar em uso).
const formatters = {};
function formatterFor(kind, options) {
  const key = `${kind}:${languageTag()}`;
  if (!formatters[key]) {
    formatters[key] = new Intl.DateTimeFormat(languageTag(), {
      timeZone: SCHOOL_TIMEZONE,
      ...options,
    });
  }
  return formatters[key];
}
const clockFormat = {
  format: (date) =>
    formatterFor("clock", { hour: "2-digit", minute: "2-digit" }).format(date),
};
const shortDateFormat = {
  format: (date) =>
    formatterFor("short", { day: "2-digit", month: "2-digit" }).format(date),
};
const longDateFormat = {
  format: (date) =>
    formatterFor("long", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date),
};

function toDate(value) {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function schoolDayKey(value) {
  const date = toDate(value);
  return date ? dayKeyFormat.format(date) : "";
}

function relativeDay(date, now = new Date()) {
  const key = dayKeyFormat.format(date);
  if (key === dayKeyFormat.format(now)) return "today";
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  if (key === dayKeyFormat.format(yesterday)) return "yesterday";
  return null;
}

// Hora da mensagem: "14:05".
export function formatMessageClock(value) {
  const date = toDate(value);
  return date ? clockFormat.format(date) : "";
}

// Horario na lista de conversas: "14:05", "Ontem" ou "03/10".
export function formatConversationTime(value) {
  const date = toDate(value);
  if (!date) return "";
  const relative = relativeDay(date);
  if (relative === "today") return clockFormat.format(date);
  if (relative === "yesterday") return i18n.t("common.yesterday");
  return shortDateFormat.format(date);
}

// Separador de dia dentro do chat: "Hoje", "Ontem" ou "3 de outubro de 2026".
export function formatDaySeparator(value) {
  const date = toDate(value);
  if (!date) return "";
  const relative = relativeDay(date);
  if (relative === "today") return i18n.t("common.today");
  if (relative === "yesterday") return i18n.t("common.yesterday");
  return longDateFormat.format(date);
}
